import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-model-edit-user',
  templateUrl: './model-edit-user.component.html',
  styleUrls: ['./model-edit-user.component.css']
})
export class ModelEditUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
